import api from './api';

export const creditReportService = {
  types: () => api.get('/credit-reports/types/'),
  orders: () => api.get('/credit-reports/orders/'),
  purchase: (data) => api.post('/credit-reports/purchase/', data),
  status: (reference) => api.get(`/credit-reports/status/${encodeURIComponent(reference)}/`),
};
